// extracted by mini-css-extract-plugin
export default {"warningIcon":"fouFQfYlcDF","warningIcon_noOffset":"fouLIIJsIjX"};